import FormBlock from '../../components/form/FormBlock.tsx';
import FormButtons from 'components/form/FormButtons';
import { getFormSchema, getUiSchema } from '../../api/secrets/formSchema.ts';
import { CreateSecretRequest, Secret } from '../../api/model.ts';
import useSecrets from 'api/secrets/useSecrets.ts';
import useProjects from 'api/projects/useProjects.ts';
import Loader from 'components/Loader.tsx';
import { SettingsFormShell } from 'components/settingsHub/SettingsFormShell';

const FORM_ID = 'secret-add-form';

type SecretAddProps = {
  projectId: string;
  onCancel: () => void;
  onSubmit: (secret: Secret) => void;
};

const SecretAdd = ({ projectId, onSubmit, onCancel }: SecretAddProps) => {
  const {
    create: { isPending, mutateAsync },
  } = useSecrets(projectId);
  const { projects, isLoading: areProjectsLoading } = useProjects();

  const handleSubmit = async (formData: CreateSecretRequest) => {
    const secret = await mutateAsync(formData);
    onSubmit(secret);
  };

  if (areProjectsLoading) {
    return <Loader />;
  }

  return (
    <SettingsFormShell
      title="Add Secret"
      footer={<FormButtons formId={FORM_ID} onCancel={onCancel} isLoading={isPending} />}
    >
      <FormBlock
        onSubmit={(formData) => void handleSubmit(formData as CreateSecretRequest)}
        onCancel={onCancel}
        schema={getFormSchema(projects, projectId)}
        uiSchema={getUiSchema(true)}
        isLoading={isPending}
        formId={FORM_ID}
        showButtons={false}
      ></FormBlock>
    </SettingsFormShell>
  );
};

export default SecretAdd;
